import React from 'react';
import {
  SkMessage, SkIssueTitle, SkMetaRow, SkVoteRow,
  SkLiveVoters, SkAwaiting, IcoTask, IcoPriority,
} from '../slack/Slack';

const META = [
  { icon: <IcoTask />,     label: 'Type',     value: 'Task' },
  { icon: <IcoPriority />, label: 'Priority', value: 'Medium' },
];
const ROW_1 = ['½', '1', '2', '3', '5', '8', '13'];
const ROW_2 = ['?', 'Defer', 'Flag'];
const VOTERS = [
  { name: 'Priya K.',  value: '5.0' },
  { name: 'Jordan M.', value: '5.0' },
  { name: 'Sam O.',    value: '3.0' },
];

export default function HeroPoll({ iconSrc }) {
  return (
    <SkMessage iconSrc={iconSrc} appName="Groomba" time="9:32 PM">
      <SkIssueTitle id="CHECK-241">Disable one-click checkout for gift cards</SkIssueTitle>
      <SkMetaRow items={META} />
      <SkVoteRow options={ROW_1} chosen="5" />
      <SkVoteRow options={ROW_2} />
      <SkLiveVoters voters={VOTERS} />
      <SkAwaiting mentions={['Alex R.', 'Mina T.']} />
    </SkMessage>
  );
}
